<template>
  <div class="card-console-wrapper">
    <div class="card-item" @click="$emit('openMoreMenu')">
      <div class="top-card">
        <div class="f-semi f-16 f-c-black">{{ idConsole }}</div>
        <img src="@/assets/icons/more-horizontal2.svg" alt=""
             style="height: 24px;"
        />
      </div>
      <div class="card-content-console">
        <div class="d-flex">
          <img src="@/assets/icons/mesin.svg" alt=""
               class="m-r-4"
               style="height: 16px;"
          />
          <div class="f-regular f-13 f-c-midgrey m-r-8">
            {{ machineCount }} Mesin terpasang
          </div>
        </div>
        <div class="d-flex">
          <img src="@/assets/icons/bookmark.svg" alt=""
               class="m-r-4"
               style="height: 16px;"
          />
          <div class="f-regular f-13 f-c-midgrey" v-if="jenis===1">Device</div>
          <div class="f-regular f-13 f-c-midgrey" v-else-if="jenis===2">Stack</div>
          <div class="f-regular f-13 f-c-midgrey" v-else-if="jenis===3">Group</div>
        </div>
      </div>
      <div class="bottom-card border-top align-items-center p-y-8">
        <div class="f-regular f-13 f-c-midgrey">Dipasang pada: {{ $moment(tanggal).format("D MMM YYYY HH:mm") }}</div>
      </div>
    </div>
    <div class="modal-action-card-console" v-if="moreMenuId === idConsole">
      <div class="modal-action-item" @click="$emit('onLihatMesin')" v-if="validateAccess('snapBridge.read')">
        <img src="@/assets/icons/mesin-biru.svg" alt=""
             class="m-r-8"
             style="height: 20px;"
        />
        <div class="f-c-black f-16">Lihat Mesin Terpasang</div>
      </div>
      <div class="modal-action-item" @click="$emit('onPinConsole')">
        <img src="@/assets/icons/lock.svg" alt=""
             class="m-r-8"
             style="height: 20px;"
        />
        <div class="f-c-black f-16">PIN Console</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SOCardSnapConsole",
  props: ["idConsole", "machineCount", "jenis", "tanggal", "moreMenuId"],
  data() {
    return {
      modalMore: false
    }
  },
}
</script>

<style scoped>
.card-console-wrapper {
  margin-bottom: 12px;
  position: relative;
}

.card-content-console {
  padding: 4px 0;
}

.modal-action-card-console {
  position: absolute;
  top: 0;
  right: 0;

  background: #FFFFFF;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

.modal-action-item {
  padding: 8px 12px;

  display: flex;
  border-top: 1px solid #EDEDED;
}
</style>